import { Table, TableBody, TableContainer, TableRow } from '@mui/material';
import { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { CustomButton } from 'src/components/button/Button';
import { PATHS } from 'src/constants/paths';
import { HeaderText } from 'src/features/assemblies/bulkReplaceReviewPage/BulkReplaceReviewPage.styled';
import { lang } from 'src/utils';

import { BulkReplaceSummaryTableRow } from '../bulkReplaceSummaryTableRow/BulkReplaceSummaryTableRow';
import {
  columns,
  getSelectedAssembiles,
} from './BulkReplaceSummaryPage.helper';
import { SummaryPageProps } from './BulkReplaceSummaryPage.interface';
import {
  ActionButtonsContainer,
  Button,
  CustomTableCell,
  CustomTableHead,
  HeaderWrapper,
  Wrapper,
} from './BulkReplaceSummaryPage.styled';

export const BulkReplaceSummaryPage = (props: SummaryPageProps) => {
  const { handleCloseSummaryPage, updatedAssemblyComponents, assemblyData } =
    props;

  const navigate = useNavigate();

  const assembliesList = getSelectedAssembiles(
    updatedAssemblyComponents,
    assemblyData,
  );

  return (
    <Wrapper>
      <HeaderWrapper>
        <HeaderText>
          {lang.stageBulkDisplayName(props.stageBulkDisplayName ?? '')}
        </HeaderText>
        <ActionButtonsContainer spacing={2} direction="row">
          <CustomButton variant="text" onClick={handleCloseSummaryPage}>
            {lang.close}
          </CustomButton>
          <Button
            variant="contained"
            onClick={() => {
              navigate({
                pathname: PATHS.ASSEMBLY_PUBLICATIONS,
              });
            }}>
            {lang.goToStagedChanges}
          </Button>
        </ActionButtonsContainer>
      </HeaderWrapper>

      <TableContainer>
        <Table stickyHeader>
          <CustomTableHead>
            <TableRow>
              {columns.map((column) => (
                <CustomTableCell key={column.key} width={column.width}>
                  {column.label}
                </CustomTableCell>
              ))}
            </TableRow>
          </CustomTableHead>
          <TableBody>
            {assembliesList?.map((assembly, key) => {
              return (
                <Fragment key={key}>
                  <BulkReplaceSummaryTableRow
                    key={key}
                    assembly={assembly}
                    isChildRow={assembly.variation_parent_id ? true : false}
                  />
                </Fragment>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Wrapper>
  );
};
